import React, { Component } from 'react';
import { connect } from 'react-redux';

import { loginRequest } from './../store/reducers/user';

import BlankLayout from './../components/layouts/blank';
import LoginForm from './../components/organisms/forms/loginForm';

class LoginPage extends Component {
  render() {
    return (
      <BlankLayout>
        <div style={styles.wrapper}>
          <div style={styles.card}>
            <div style={styles.logoSection}>
              <img src="/images/logo1.png" alt="Genia" style={styles.logo} />
            </div>
            <h2 style={styles.title}>Bienvenidos a Genia Comunidad</h2>
            <p style={styles.subtitle}>Administración del Sistema de Autopréstamo</p>
            <div style={styles.divider} />
            <h3 style={styles.formTitle}>Iniciar sesión</h3>
            <p style={styles.formSubtitle}>Ingresa tus datos de acceso</p>
            <LoginForm
              action={this.props.loginRequest}
              disabled={this.props.loggingIn}
              loading={this.props.loggedIn}
            />
          </div>
        </div>
      </BlankLayout>
    );
  }
}

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: '100vh',
    backgroundColor: '#f5f6fa',
    paddingTop: 80,
    padding: '80px 20px 20px 20px',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 16,
    boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
    padding: '40px 36px',
    width: '100%',
    maxWidth: 420,
  },
  logoSection: {
    textAlign: 'center',
    marginBottom: 16,
  },
  logo: {
    height: 48,
  },
  title: {
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 700,
    color: '#333',
    margin: '0 0 4px 0',
  },
  subtitle: {
    textAlign: 'center',
    fontSize: 14,
    color: '#666',
    margin: '0 0 20px 0',
    fontWeight: 400,
  },
  divider: {
    height: 1,
    backgroundColor: '#eee',
    margin: '0 0 24px 0',
  },
  formTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: '#444',
    margin: '0 0 4px 0',
  },
  formSubtitle: {
    fontSize: 13,
    color: '#888',
    margin: '0 0 20px 0',
  },
};

const mapStateToProps = state => ({
  loggedIn: state.user.loggedIn,
  loggingIn: state.user.loggingIn,
});

const mapDispatchToProps = dispatch => ({
  loginRequest: (credentials) => dispatch(loginRequest(credentials))
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
